import clsx from 'clsx';
import React, { FC, PropsWithChildren } from 'react';
import { Stack } from '../../stack';
import classes from './confirmation-card-footer.module.scss';

export type ConfirmationCardFooterProps = PropsWithChildren<{
  /**
   * Render divider at top
   */
  divider?: boolean;
}>;

export const ConfirmationCardFooter: FC<ConfirmationCardFooterProps> = ({
  children,
  divider,
}) => {
  return (
    <Stack
      className={clsx(classes.root, 'confirmation-card-footer-component', { [classes.divider]: divider })}
      fill
      direction="column"
      align="center"
      crossAxis="center"
      spacing={2}
    >
      {children}
    </Stack>
  );
};
